import { Inject, Injectable } from '@angular/core';
import {
  Router,
  NavigationEnd,
  ActivatedRoute,
  RouterState,
} from '@angular/router';
import { Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';

declare let gtag: Function;

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  constructor(
    private router: Router,
    private titleService: Title,
    @Inject(DOCUMENT) private document: Document
  ) {}

  handleRouteEvents() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const title = this.getTitle(
          this.router.routerState,
          this.router.routerState.root
        ).join(' | ');
        this.titleService.setTitle(title);
        this.sendPageViewAnalytics(
          title,
          event.urlAfterRedirects,
          this.document.location.href
        );
      }
    });
  }

  private getTitle(state: RouterState, parent: ActivatedRoute): string[] {
    const data = [];
    if (parent && parent.snapshot.data && parent.snapshot.data['title']) {
      data.push(parent.snapshot.data['title']);
    }
    if (state && parent && parent.firstChild) {
      data.push(...this.getTitle(state, parent.firstChild));
    }
    return data;
  }

  private sendPageViewAnalytics(
    pageTitle: string,
    pagePath: string,
    pageLocation: string
  ) {
    gtag('event', 'page_view', {
      page_title: pageTitle,
      page_path: pagePath,
      page_location: pageLocation,
    });
  }
}
